'use strict'

export default function riskResponseLabel(response,language) {
  let languageLabels={
    norwegian: {
      responses: {
        "Reduce":"Reduseres",
        "Avoid": "Unngås",
        "Transfer":"Overføres",
        "Accept":"Aksepteres",
        "Share":"Deles",
        "Enhance":"Forbedres",
        "Exploit":"Utnyttes",
        "Reject":"Avvises",
        "ContingencyPlan":"Beredskapsplan"
      }
    },
  };
  let labels=(languageLabels[language]);
  return labels!==undefined && labels.responses!==undefined && labels.responses[response] ? labels.responses[response] : response;
}



// WEBPACK FOOTER //
// ./views/risk/riskResponseLabel.js